import { Errors } from 'components/Form/InputError'
import { Campaign } from 'types/campaign'

export type FormData = {
  asId: string
  startDate: Campaign['startDate'] | null
  endDate: Campaign['endDate'] | null
}

export const formDataDefault: FormData = {
  asId: '',
  startDate: null,
  endDate: null,
}

export interface FormDataErrors {
  asId: Errors
}

export const formDataErrorsDefault: FormDataErrors = {
  asId: [],
}
